import {
  Directive,
  effect,
  inject,
  Input,
  type OnChanges,
  type SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { toSignal } from '@angular/core/rxjs-interop';
import { type UserRole } from '@szebit-app/sdk/backend';
import { UserStateSelectors } from '../state/user-state-selectors';
import { Store } from '@ngxs/store';

@Directive({
  selector: '[appHasAccess]',
  standalone: true,
})
export class HasAccessDirective implements OnChanges {
  readonly #authService = inject(AuthService);
  readonly #templateRef = inject(TemplateRef);
  readonly #viewContainer = inject(ViewContainerRef);
  readonly #store = inject(Store);

  readonly #isLoggedIn = toSignal(this.#authService.isAuthenticated$, {
    initialValue: false,
  });

  @Input() appHasAccess!: UserRole;

  constructor() {
    effect(() => {
      this.updateView();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appHasAccess'] !== undefined && changes['appHasAccess'].firstChange === false) {
      this.updateView();
    }
  }

  private updateView(): void {
    if (
      this.#isLoggedIn() &&
      this.appHasAccess !== undefined &&
      this.#store.selectSnapshot(UserStateSelectors.hasAccess(this.appHasAccess))
    ) {
      if (this.#viewContainer.length === 0) {
        this.#viewContainer.createEmbeddedView(this.#templateRef);
      }
    } else {
      this.#viewContainer.clear();
    }
  }
}
